<template>
  <v-toolbar-title class="ml-0 pa-0 align-center d-none d-lg-flex">
    <v-icon class="ml-4 mr-2">mdi-map-marker-outline</v-icon>
    <span class="subtitle-1 text-truncate" style="max-width:130px">{{ direcciones.calle }}</span>
    <v-icon class="ml-4 mr-2">mdi-clock-outline</v-icon>
    <span
      class="subtitle-1 text-truncate"
      style="max-width:280px"
    >Aprox. {{ activeRestObj.tiempoDomicilio }} min.</span>
  </v-toolbar-title>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "headerToolbarRestaurante",
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState({
      activeRestObj: state => state.pedido.restauranteObjPedido,
      direcciones: state => state.pedido.direccionPedido
    }),
    ...mapGetters({
      //cantidad: 'pedido/precioPedido'
      // esDomicilio: "pedido/esDomicilio"
    })
  },
  methods: {},
  beforeMount() {},
  mounted() {}
};
</script>

<style scoped>
</style>